module.exports = __webpack_public_path__ + "img/thumb_24.136f32c2.jpg";